<template>
  <content-loader
    view-box="0 0 430 80"
    :speed="2"
    primary-color="#f3f3f3"
    secondary-color="#ecebeb"
  >
    <circle cx="200" cy="32" r="32" /> 
    <circle cx="224" cy="49" r="7" />
  </content-loader>
</template>

<script>
import { ContentLoader } from "vue-content-loader";

export default {
    name: "AvatarLoader",
    components: { ContentLoader }
};
</script>